import { environment } from "../environments/environment";

export class AppSettings {

    public static portApi = 3333; // 3333 "ws://"
    public static portWs = 3335;
    public static protocol = window.location.protocol + '//';
    public static apiUrl = AppSettings.protocol + location.hostname + ":" + AppSettings.portApi + "/api/";
    public static wsUrl = 'wss://' + location.hostname + ":" + AppSettings.portWs;
    public static wsUrlhttp = 'ws://' + location.hostname + ":" + AppSettings.portWs;
    public static ddataApiKey = "59b1609de246dc4e4f0c7c5eac29948c1924c1e7";
    public static urlPayments = location.hostname == "localhost" || location.hostname == "ag-test.renlife.com" ? "https://pay.cloud-test.renlife.com/v1/api/payments" : "https://pay.cloud.renlife.com/v1/api/payments";
    //public static apiUrl = "https://ag-test.renlife.com:3333/api/"

    // Тестовый адрес оплаты
    public static paymentEndpoint = location.hostname == "ag-test.renlife.com" ?
        "https://lifecabinet-pred.renlife.com/acquiring_bank_russian_standard/payment_external_from_get_wp" :
        "https://lifecabinet.renlife.com/acquiring_bank_russian_standard/payment_external_from_get_wp";

    public static PersonsEndpoint = "persons";

    static get IsTest(): boolean {
        return location.hostname == "localhost" || location.hostname == "ag-test.renlife.com";
    }
}